import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { useIntl } from 'react-intl';
import { withStyles, Tooltip } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import HelpIcon from '@material-ui/icons/Help';
import { getI18n, getI18nFormattedMessage } from '../../../../utils/intl';

import styles from './styles';

const getGatewayApiCount = (gatewayApiSyncLog, selectedCount) => {
  try {
    return JSON.parse(gatewayApiSyncLog).deployReqCount;
  } catch (e) {
    return selectedCount;
  }
};

const getPortalApiCount = (gatewayApiSyncLog) => {
  try {
    return JSON.parse(gatewayApiSyncLog).portalApiCount;
  } catch (e) {
    return 0;
  }
};

const DetailCardRaw = ({
    details,
    title,
    titleIcon,
    totalCount,
    selectedCount = 0,
    portalApis,
    portalPublishedCount,
    gatewayPublishedCount,
    displayLastSync = true,
    displayProxyCount = true,
    classes,
  }) => {
  const intl = getI18n(useIntl());
  const lastDeployedDate = portalApis.results.length > 0 ?
    portalApis.results[0].lastTimeDeployedDate : null;
  const lastSyncDateTime = (lastDeployedDate) ? new Date(lastDeployedDate).toString() : 'NA';
  const portalCount = totalCount;
  const gatewayApiSyncLog = get(details, 'GatewayApiSyncLog');
  const gatewayApiCount = getGatewayApiCount(gatewayApiSyncLog, selectedCount);
  const portalApiCount = getPortalApiCount(gatewayApiSyncLog);
  const totalProxyCount = gatewayApiCount + portalApiCount;
  const outSync = !(parseInt(portalCount, 10) === parseInt(totalProxyCount, 10));

  return (
    <Card data-apim-test="proxy-details-api-card" className={classes.card}>
      <CardContent>
        <Typography component={'h3'} className={classes.title} gutterBottom>
          <span className={classes.titleIcon}>{titleIcon}</span>
          <span className={classes.titleText}>{title}</span>
        </Typography>
        <Divider className={classes.divider} />
        <Fragment>
          {displayLastSync &&
            <Fragment>
              <Typography component={'div'} className={classes.lastSync}>
                <h4>{getI18nFormattedMessage('label.proxy.details.api.last.deployed')}</h4>
              </Typography>
              <Typography component={'div'} data-apim-test="proxy-details-api-card-date" className={classes.lastSync}>
                <span className={classes.iconStatusText}>{lastSyncDateTime}</span>
              </Typography>
            </Fragment>
          }
          <Typography component={'div'} data-apim-test="proxy-details-api-card-description" className={classes.description}>
            <span className={classes.iconStatus}><CheckIcon style={{ fontSize: 16, color: 'green' }} /></span>
            <span className={classes.iconStatusText}>{intl.getI18nMessage('label.proxy.details.api.portal')}: {portalCount}</span>
            <Tooltip
              data-apim-test="proxy-details-api-card-portal-helptext"
              title={getI18nFormattedMessage('label.proxy.details.api.card.helptext')}
              arrow placement="right"
            >
              <HelpIcon className={classes.helpIcon} />
            </Tooltip>
            <Typography component={'div'} data-apim-test="proxy-details-api-card-count-container">
              <span className={classes.publishText} data-apim-test="proxy-details-api-card-portal-container">
                {`${intl.getI18nMessage('label.proxy.details.api.portal.published')}: ${portalPublishedCount}`}
              </span>
              <span className={classes.publishText} data-apim-test="proxy-details-api-card-gateway-container">
                {`${intl.getI18nMessage('label.proxy.details.api.gateway.published')}: ${gatewayPublishedCount}`}
              </span>
            </Typography>
          </Typography>
          {displayProxyCount &&
            <Typography component={'div'} className={classes.description} data-apim-test="proxy-details-api-card-proxy-container">
              <span className={classes.iconStatus}>
                {outSync
                  ? <CloseIcon className={classes.errorIconRoot} />
                  : <CheckIcon className={classes.successIconRoot} />
                }
              </span>
              <span className={classes.iconStatusText}>{`${totalProxyCount} ${intl.getI18nMessage('label.proxy.details.api.proxy')}`}</span>
              <Typography component={'div'} data-apim-test="proxy-details-api-card-proxy-count-container">
                <span className={classes.publishText} data-apim-test="proxy-details-api-card-proxy-portal-container">
                  {`${intl.getI18nMessage('label.proxy.details.api.portal.published')}: ${portalApiCount}`}
                </span>
                <span className={classes.publishText} data-apim-test="proxy-details-api-card-proxy-gateway-container">
                  {`${intl.getI18nMessage('label.proxy.details.api.gateway.published')}: ${gatewayApiCount}`}
                </span>
              </Typography>
            </Typography>
          }
        </Fragment>
      </CardContent>
    </Card>
  );
};

DetailCardRaw.propTypes = {
  details: PropTypes.shape({}),
  title: PropTypes.string,
  titleIcon: PropTypes.node,
  totalCount: PropTypes.number,
  portalApis: PropTypes.shape({}),
  portalPublishedCount: PropTypes.number,
  gatewayPublishedCount: PropTypes.number,
  selectedCount: PropTypes.number,
  displayLastSync: PropTypes.bool,
  displayProxyCount: PropTypes.bool,
  classes: PropTypes.shape({}),
};

DetailCardRaw.displayName = 'ApiCard';

export default withStyles(styles)(DetailCardRaw);



// WEBPACK FOOTER //
// ./src/pages/ApiProxy/Details/ApiCard/index.js